import { createHubspotTicket } from '@common/api/hotel';
import { HubspotTicketPayload } from '@common/api/hotel/types';
import { useNotificationsStore } from '@common/store/notifications';
import { useMutation } from '@tanstack/react-query';

export const useHSTicket = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const { addNotification } = useNotificationsStore();

  const { mutate, isPending: isLoading } = useMutation({
    mutationFn: (data: HubspotTicketPayload) => {
      return createHubspotTicket(data);
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: () => {
      addNotification('fail', 'Failed to create the ticket');
    }
  });

  return {
    createHSTicket: mutate,
    isLoading
  };
};
